import styled, { css } from "styled-components";
import icoCross from './images/ico-cross.svg';
import icoOpenMobile from './images/ico-help-mobile.svg';

export const HelpWrapper = styled.div`
  position: fixed;
  right: 40px;
  top: 40px;
  z-index: 50;
  @media (max-width: 991px){
    left: 0px;
    right: inherit;
    width: 100%;
    right: inherit;
    position: absolute;
    top: inherit;
  }
`;

export const HelpContainer = styled.div<{active?: boolean}>`
  position: fixed;
  right: -500px;
  top: 0px;
  z-index: 40;
  background-color: #fff;
  width: 500px;
  height: 100vh;
  overflow-y: scroll;
  -webkit-transition: all .3s;
  -moz-transition: all .3s;
  transition: all .3s;
  -webkit-box-shadow: 0px 0px 106px 8px rgba(0,0,0,0.45);
  -moz-box-shadow: 0px 0px 106px 8px rgba(0,0,0,0.45);
  box-shadow: 0px 0px 106px 8px rgba(0,0,0,0.45);
  ${props => props.active && css`
      right: 0px;
    `}
  @media (max-width: 991px){
    width: 100%;
    right: -100%;  
    ${props => props.active && css`
      right: 0%;
    `}
  }
`;

export const HelpContent = styled.div`
  padding: 100px 80px;
  color: #000;
  text-align: center;
  padding-top: 120px;
  font-size: 12px;
  h1{
    text-transform: uppercase;
    font-size: 18px;
    margin-bottom: 20px;
  }
  @media (max-width: 991px){
    padding: 100px 50px;
  }
  p, ul li{
    font-size: 12px;
    line-height: 20px;
  }
  ul{
    margin: 0px;
    padding: 10px 20px;
  }
`;

export const HelpClose = styled.div`
  position: absolute;
  top: 50px;
  left: 30px;
  width: 30px;
  cursor: pointer;
  height: 30px;
  border-radius: 0px;
  border: 0px solid #000;
  background-image: url(${icoCross});
  background-size: 25px auto;
  background-position: center center;
  background-repeat: no-repeat;
  @media (max-width: 991px){
    right: 25px;
    top: 35px;
    left: inherit;
    z-index: 100;
  }
  &:hover{
    background-color: #ccc;
    border:1px solid #ccc;
  }
`;

export const HelpOpenMobile = styled.div<{active?: boolean}>`
  position: absolute;
  top: 30px;
  right: 20px;
  width: 25px;
  z-index: 50;
  height: 25px;
  background-image: url(${icoOpenMobile});
  background-size: 25px auto;
  background-position: center center;
  background-repeat: no-repeat;
  display: block;
  @media (min-width: 992px){
    display: none;
  }
  ${props => props.active && css`
      display: none;
    `}
`;


export const HelpList = styled.ul<{active?: boolean}>`
  background-color: #fff;
  border-radius: 0px;
  margin: 0px;
  padding: 0px;
  color: #000;
  overflow: hidden;
  z-index: 98;
  position: relative;
  -webkit-box-shadow: 0px 0px 56px 8px rgba(0,0,0,0.25);
  -moz-box-shadow: 0px 0px 56px 8px rgba(0,0,0,0.25);
  box-shadow: 0px 0px 56px 8px rgba(0,0,0,0.25);
  ${props => props.active && css`
    background-color: #fff;
  `}
  @media (max-width: 991px){
    display: none;
    margin-top: 0px;
    position: fixed;
    top: 30px;
    left: 10px;
    ${props => props.active && css`
      display: block;
    `}
  }
`;

export const HelpListItem = styled.li<{active?: boolean}>`
  display: inline-block;
  text-align: center;
  border-right: 1px solid #ddd;

  

  &:last-child{
    border-right: 0px;
  }
  a{
    color: #000;
    font-weight: bold;
    text-decoration: inherit;
    height: 42px;
    text-transform: uppercase;
    line-height: 42px;
    padding: 0px 20px;
    display: block;
    font-size: 12px;
    letter-spacing: 1
    0px;
    cursor: pointer;
    @media (max-width: 991px){
      font-size: 14px;
      padding: 0px 20px;
      height: 40px;
      line-height: 40px;
    }
    &:hover{
      background-color: #111;
      color: #fff;
    }

    ${props => props.active && css`
      a{
        background-color: #00b6b2;
        color: #fff;
      }
    `}
  }
`;
